import {
  PopoverArrow as PopoverArrowPrimitive,
  type PopoverArrowProps,
} from '@radix-ui/react-popover';

import cn from '../../../utils/cn';

const PopoverArrow = (props: PopoverArrowProps) => {
  const { className, ...otherProps } = props;
  return (
    <PopoverArrowPrimitive asChild className='-mt-[6px]' {...otherProps}>
      <svg
        className={cn('rotate-180 fill-white stroke-gray-light', className)}
        width='24'
        height='24'
        viewBox='0 0 64 64'
        strokeWidth='3'
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
      >
        <polyline points='57.47 45.15 30.84 19.88 6.58 45.15' />
      </svg>
    </PopoverArrowPrimitive>
  );
};

export default PopoverArrow;
